import { ActiveBrandService } from '@go-modules/services/active-brand';

/* @ngInject */
export function AccountSetupWizardViewController (appData, $translate, activeBrand: ActiveBrandService) {
	const vm = this;
	const productTranslationParams = activeBrand.getTranslationParams();

	vm.$onInit = () => {
		vm.user = appData.currentUser;
		vm.group = appData.userGroup;
		vm.account = appData.myAccount;
		vm.useTypes = appData.useTypes;
		vm.title = $translate.instant(
			'account-setup-wizard-view_account-verification-title',
			productTranslationParams
		);
	};
}
